import { useEffect } from "react";
import "../../components/BlogPost.css";

export default function DefiningGoal(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <img
          className="singlePostImg"
          src="https://images.unsplash.com/photo-1445821185708-62c36d070323?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1353&q=80"
          alt=""
        />
        <h1 className="singlePostTitle">
          A guide of defining one’s goal in life
        </h1>
        <p className="singlePostDesc">
          <b>
            <i>
              Without a goal, we just flow aimlessness through the stream of
              life and most likely end up in mediocrity.
            </i>
          </b>
          <br />
          <br />
          Very few people realize their goals, which means that these people
          often do not find happiness and fulfillment in life. <br />
          Most of them do not even try. What is even sadder, however, is that
          the vast majority of people do not even know what their goals are.
          <br />
          <br />
          After I found myself at the beginning of this aimlessness and my
          motivation to swim against the stream began to suffer, i decided to
          set up a 4 step plan to clearly formulate my goals and define concrete
          steps that should bring me closer to my goal.
          <br />
          <br />
          This blog will illustrate this plan on the basis of my own example. So
          that you can use my example as a template for your own goal.
          <br />
          <br />
          <big>
            <b>Step 1:</b>
          </big>
          <br />
          <br />
          The first step is to find out what is really important to you.
          <br />
          To do so, you need to think about what makes you happy. For this,
          remind yourself of moments when you felt great. Which achievements
          have been the most fulfilling for you? Which situations trigger the
          greatest feelings of envy?
          <br />
          Afterwards reflect on these situations to get to the deep desire
          behind them.
          <br />
          <br />
          For example, some of my realizations looked like this. Whenever there
          are great people around me, it make me feel better. When I hear about
          someone who have found a way to get past unfulfilling and boring work,
          I feel jealous. Whenever I can give a lot of value to others through
          my skills, I feel fulfilled. From this and other memories, I was able
          to identify general directions, which might look like the following.
          <br />
          <br />
          <ol className="normalWeightList" style={{ paddingLeft: "30px" }}>
            <li>
              To be surrounded by reflective and fulfilled people with whom I
              can cultivate deep and mutually reinforcing relationships.
            </li>
            <li>
              To have the possibility to decide freely about my time and do not
              have to exchange it for money.
            </li>
            <li>
              To create something of value to others and positively impact their
              lives.
            </li>
            <li>
              To be healthy and have the opportunity to approach physical goals.
              By the way,
            </li>
          </ol>
          <br />
          <br />
          <big>
            <b>Step 2:</b>
          </big>
          <br />
          <br />
          In the second step, with your desires from the first step you will
          imagine an optimized scenario that will serve as a precise goal and
          motivation for the concrete actions that will be worked out in the
          fourth step.
          <br />
          <br />
          The idea behind this step is that whenever you visualize the image of
          your goal, you should automatically create a link to the concrete
          actions that are within your direct circle of control and thus
          redirect the motivation that arises from your dream scenario to
          concrete actions.
          <br />
          <br />
          My dream scenario looks like that: Together with great people I want
          to create a special place in a beautiful location where we will be a
          community of like-minded people. The goal is that everyone can pursue
          their own goal, but strengthen each other. I myself want to create a
          co-working space and from there develop software that could provide
          value to many people. But I also want to teach self-improvement and
          body control training like acrobatics, yoga and calisthenics. I want
          all my peers to follow their own creative dreams and generate value
          from this place. There will be a yoga school or retreat, a hostel
          teaching local history. Some friends will build tree houses, others
          may just farm, others will publish the content they create on the
          internet. This place should be seen like a business in which the
          founders are heavily invested. The place should be self-sustaining,
          grow, have the possibility to give, and be open to all kinds of
          interesting characters.
          <br />
          <br />
          <big>
            <b>Step 3:</b>
          </big>
          <br />
          <br />
          In the third step, you write down for each of the desires you worked
          out in the first step, firstly (a), what you can improve on and,
          secondly (b), independent of the learning part, how you can invest
          work into realizing these desires. For me that looked like this:
          <br />
          <br />
          <ol
            type="1"
            className="normalWeightList"
            style={{ paddingLeft: "30px" }}
          >
            <li>Socialization</li>
            <ol
              type="a"
              className="normalWeightList"
              style={{ paddingLeft: "30px" }}
            >
              <li> Relationships, psychology, conversation and reflection.</li>
              <li>
                {" "}
                Meet more people through travel, events, joining communities and
                generally showing more interest in strangers.
              </li>
            </ol>
            <li>Financial freedom</li>
            <ol
              type="a"
              className="normalWeightList"
              style={{ paddingLeft: "30px" }}
            >
              <li> Financial intelligence, economics, entrepreneurship.</li>
              <li>
                {" "}
                Founding businesses, building assets, keeping liabilities small
              </li>
            </ol>
            <li>Value creation</li>
            <ol
              type="a"
              className="normalWeightList"
              style={{ paddingLeft: "30px" }}
            >
              <li> Individual skills and knowledge</li>
              <li>
                {" "}
                Creating reach and scale, finding problems, working on
                solution-oriented projects.
              </li>
            </ol>
            <li>Physical</li>
            <ol
              type="a"
              className="normalWeightList"
              style={{ paddingLeft: "30px" }}
            >
              <li> Diet, exercise techniques, body-mind connection</li>
              <li> Practice, experiment.</li>
            </ol>
          </ol>
          <br />
          <br />
          I highly recommend reading books. My top picks for these topics can be
          found under the tab Books.
          <br />
          <br />
          <big>
            <b>Step 4:</b>
          </big>
          <br />
          <br />
          The last step is to make a list of a few but really important actions
          and habits that bring you closer to your goal. For me that looks like
          this:
          <br />
          <br />
          <i>Habits: </i> Training and health habits, building software
          regularly, accumulate assets.
          <br />
          <br />
          <i>Actions: </i> Travel to look for these places, talk about the dream
          to recruit peers.
          <br />
          <br />
          It is then really important that you strengthen the link between these
          actions and habits with your goal. Without a reason, building good
          habits will fail.
        </p>
      </div>
    </div>
  );
}
